/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import 'simplebar';
import 'lightgallery';
import 'highlight.js';
import 'select2';
window.Dropzone = require('dropzone');
Dropzone.autoDiscover = false;
window.swal = require('sweetalert');
window.Swal = require('sweetalert2');

window.Vue = require('vue');

window.tinyMce = require('tinymce');
require('tinymce');
require('tinymce/plugins/paste');
require('tinymce/plugins/lists');
require('tinymce/plugins/link');
require('tinymce/plugins/table');
require('tinymce/plugins/contextmenu');
require('tinymce/plugins/help');
require('tinymce/plugins/wordcount');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));


/**
 * Create a global Event Bus to share stated between componenes
 */
Vue.prototype.$eventBus = new Vue();

Vue.component('bookmark', require('./components/Bookmark.vue').default);
Vue.component('bookmark-count', require('./components/BookmarkCount.vue').default);
Vue.component('phone-reveal', require('./components/PhoneReveal.vue').default);
Vue.component('email-reveal', require('./components/EmailReveal.vue').default);
Vue.component('activate-toggle', require('./components/ActivateToggle.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});

// Custom JS
let thisSite = (function ($) {
    'use strict';

    const $stickyDropdownMenu = $('.sticky-dropdown-menu');

    // Toolip init
    function tooltipInit() {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        })
    }

    // Sticky menu behaviour
    function menuAnimations() {
        const stickyMenu = document.querySelector('#sticky-menu');
        const $stickyMenu = $('#sticky-menu');
        const stickyHamburgerButton = document.querySelector('#sticky-menu .burger');

        const scrollFunction = function () {
            if (window.pageYOffset > 200) {
                stickyMenu.classList.add('sticky');
                $stickyMenu.slideDown();
            } else {
                stickyMenu.classList.remove('sticky');
                $stickyMenu.slideUp();
                $stickyDropdownMenu.slideUp();

                stickyHamburgerButton.classList.remove('burger-active');
            }
        };

        let isScrolling;
        window.addEventListener('scroll', function () {
            window.clearTimeout(isScrolling);
            isScrolling = setTimeout(scrollFunction, 50);
        }, false);
    }

    // Sticky logo go to top
    function stickyLogoGoToTop() {
        $('#sticky-menu .site-logo-blue').on('click', function() {
            $('html, body').animate({ scrollTop: 0 }, 400);
        });
    }

    // Hamburger open/close animation
    function hamburgerMenu() {
        const hamburgerButton = document.querySelectorAll('.burger');

        hamburgerButton.forEach(function (item) {
            item.addEventListener('click', function () {
                item.classList.toggle('burger-active');
            });
        });
    }

    // Sidebar Filer respo behaviour
    function filterBarBehaviour() {
        const filterButton = document.querySelector('#filter-respo-button');
        const filterMenu = document.querySelector('#cat-filter-wrapper');
        const filterCloseButton = document.querySelector('#filter-respo-remove');
        const bodyBackdrop = document.querySelector('#cat-filter-backdrop');

        if (filterButton === null) {
            return;
        }

        const items = [
            filterButton,
            filterCloseButton,
            bodyBackdrop
        ];

        items.forEach(function (item) {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                toggleSidebarClasses();
            });
        });

        function toggleSidebarClasses() {
            filterMenu.classList.toggle('cat-filter-active');
            bodyBackdrop.classList.toggle('visible');
            document.body.classList.toggle('active-backdrop');
        }
    }

    // Responsive dropdown menu behavior
    function dropdownBehavior() {

        const $dropdownMenuButton = $('.header-menubar .burger');
        const $dropdownMenu = $('.header-dropdown-menu');
        const $stickyBottombar = $('#sticky-bottombar');
        const $stickyDroprownButton = $('#sticky-menu .burger');
        const $stickyBarHeight = $('#sticky-menu').outerHeight();

        class DropdownFunctions {
            constructor(button, menu, heightItem) {
                this.button = button;
                this.menu = menu;
                this.heightItem = heightItem;
            }

            setSlideToggle() {
                const that = this;
                this.button.on('click', function() {
                    that.menu.slideToggle(400);
                });
            }

            setProperHeight() {
                this.menu.css('top', $stickyBarHeight);
                this.heightItem.css('margin-bottom', $stickyBarHeight);
            }

            toggleAndHeight() {
                this.setProperHeight();
                this.setSlideToggle();
            }
        }

        const headerBurger = new DropdownFunctions($dropdownMenuButton, $dropdownMenu);
        const stickyBurger = new DropdownFunctions($stickyDroprownButton, $stickyDropdownMenu, $stickyBottombar);

        stickyBurger.toggleAndHeight();
        headerBurger.setSlideToggle();
    }

    // Accordion toggle icon behaviour
    function accordionToggle() {
        $('#category-accordion').on('hide.bs.collapse show.bs.collapse', e => {
            $(e.target)
                .prev()
                .find('.toggle-icon')
                .toggleClass('icon-reverse-y');
        })
    }

    // Registration form - farming area toggle
    function farmingAreaToggle() {
        $('select[name="gazdTer"]').on('change', function (e) {
            // val8 is the ID of 'no fields'
            if ($(this).val() != 'val9') {
                $('.farming-area-toggle').slideDown(200);
            } else {
                $('.farming-area-toggle').slideUp(200);
            }
        })
    }

    // Feedback button toggle
    function feedbackToggle() {
        $('#feedbackButton').on('click', function (e) {
            $('#feedbackContainer').slideToggle();
        })
    }

    // Message button toggle
    function messageToggle() {
        $('#messageButton').on('click', function (e) {
            $('#messageContainer').slideToggle();
        })
    }

    // Profile button behaviour on smaller devices
    function maxWidthLarge() {
        const smallerDevices = window.matchMedia('(max-width: 1200px)');
        const profileButton = document.querySelector('.profile-dropdown-button');
        const profileDropdownContainer = document.querySelector('.profile-dropdown');

        if(profileDropdownContainer === null) {
            return;
        }

        function respoDropdown(size) {

            if(size.matches) {
                profileDropdownContainer.style.display = 'none';

                profileButton.addEventListener('click', function (e) {
                    e.preventDefault();

                    if(profileDropdownContainer.style.display === 'none') {
                        profileDropdownContainer.style.display = 'flex';
                    } else {
                        profileDropdownContainer.style.display = 'none';
                    }
                });
            }
        }
        respoDropdown(smallerDevices);
    }

    // Registration submit button behaviour
    function registerButtonState() {
        const registerButton = document.querySelector('#submitRegister');
        const registerForm = document.querySelector('#registerForm');
        const asz = document.querySelector('#asz');
        const aszf = document.querySelector('#aszf');

        if(registerForm === null) {
            return
        }

        const inputs = [
            asz,
            aszf
        ];

        registerButton.style.cursor = 'not-allowed';

        inputs.forEach((item) => {
            item.addEventListener('change', theChecker);
        });

        function theChecker() {
            let checked = 0;

            for (let i = 0; i < inputs.length; i++) {
                if (inputs[i].checked) {
                    checked++;
                }
            }

            if (checked > 1) {
                registerForm.action = registerForm.dataset.url;
                registerButton.disabled = false;
                registerButton.style.cursor = 'pointer';
            } else {
                registerForm.action = '';
                registerButton.disabled = true;
                registerButton.style.cursor = 'not-allowed';
            }
        }
    }

    // Business registration container toggle
    function businessRegToggle() {

        $('input[name="is_company"]').on('change', function () {
            if (this.checked) {
                $('#businessDataContainer').slideDown(200);
            } else {
                $('#businessDataContainer').slideUp(200);
            }
        })
    }

    // Search bar functionality
    function apSearch() {
        var $catSelect = $('.ap-fp-search .category-select');

        $('a', $catSelect ).click(function(e){

            e.preventDefault();

            // Change selected text
            $('.selected-text', $catSelect ).text($(this).text());

            // Add value to the hidden element
            $('input[name=category]', $catSelect ).val($(this).data('slug'));
        });
    }

    // Init Lightgallery on carousel items
    function initLightGallery() {
        $("#apCarouselImages .carousel-inner").lightGallery({
            selector: '.item'
        });
    }

    // Init Select2
    function initSelect2() {

        // Custom matcher to search from the beginning of a word in the option list
        function matchStart(params, data) {
            params.term = params.term || '';
            if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
                return data;
            }
            return false;
        }

        $(".select2").select2({
            matcher: function(params, data) {
                return matchStart(params, data);
            },

            // See: https://www.npmjs.com/package/@ttskch/select2-bootstrap4-theme
            theme: 'bootstrap4',
        });

        $(".select2-city").select2({
            matcher: function(params, data) {
                return matchStart(params, data);
            },

            // See: https://www.npmjs.com/package/@ttskch/select2-bootstrap4-theme
            theme: 'bootstrap4',

            language: {
                inputTooShort: function(args) {
                    return "Írjon be legalább " + args.minimum + ' karaktert!';
                },
                searching: function() {
                    return "Keresés...";
                },
                noResults: function() {
                    return "Nincs találat.";
                },
            },

            minimumInputLength: 3,

            ajax: {
                url: "/varos/kereses",
                dataType: 'json',
                delay: 250,
                /*data: function (params) {

                    var query = {
                        search: params.term,
                    }

                    // Query parameters will be ?search=[term]&type=public
                    return query;
                },*/
                processResults: function (response) {

                    return {
                        results: response
                    };
                },
                cache: true
            }
        });

    }

    /**
     * Add confirmation dialog to product delete buttons
     */
    function productDeleteConfirm() {

        const deleteButtons = document.querySelectorAll('.product-delete-btn');

        deleteButtons.forEach(function (item) {

            item.addEventListener('click', function (e) {

                e.preventDefault();

                const parentform = item.parentNode;

                Swal.fire({
                    title: 'Biztos benne?',
                    text: "A törlés végleges!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#4f84d2',
                    cancelButtonColor: '#f5a623',
                    confirmButtonText: 'Igen',
                    cancelButtonText: 'Mégsem'
                }).then((result) => {
                    if (result.value) {

                        parentform.submit();

                        return true;
                    } else {
                        return false;
                    }
                })

            });

        });
    }

    /**
     * Sorting the lists - Append "sort" URL parameter and reload page
     */
    function listSortDropdown() {

        if (document.querySelector('#sort') === null) {
            return;
        }

        document.querySelector('#sort').addEventListener('change', function(e) {

            if (e.target.value != '-') {
                let urlParams = new URLSearchParams(window.location.search);
                urlParams.set('sort', e.target.value);
                urlParams.toString();

                window.location.search = urlParams.toString();
            }
        });
    }

    return {

        initProtocol: {
            1: [10, menuAnimations],
            2: [50, feedbackToggle],
            3: [60, messageToggle],
            4: [100, accordionToggle],
            5: [100, farmingAreaToggle],
            6: [100, businessRegToggle],
            7: [200, stickyLogoGoToTop],
            8: [200, apSearch],
            9: [200, tooltipInit],
            10: [50, initLightGallery],
            11: [300, hamburgerMenu],
            12: [300, dropdownBehavior],
            13: [300, initSelect2],
            14: [500, filterBarBehaviour],
            15: [100, productDeleteConfirm],
            16: [50, maxWidthLarge],
            17: [100, registerButtonState],
            18: [100, listSortDropdown]
        },

        // Initialization
        init: function () {

            // Init the components
            $.each(this.initProtocol, function () {
                setTimeout(this[1], this[0]);
            });
        }
    };

})(jQuery);

jQuery(document).ready(function () {
    thisSite.init($);
});
